import * as React from "react"
import T from "../T/T";
import "./styles.scss";
import ClaimRewardBtn from "../ClaimRewardBtn";
import useEmblaCarousel from "embla-carousel-react";

export default function NbcOffers({ type, offers, showReward }) {
    const [emblaRef] = useEmblaCarousel({
        align: 'center',
        loop: true
    });

    return (
        <div className="block-container">
            { offers?.length > 1 ? (
                <div
                    style={{overflow: "hidden"}}
                    ref={emblaRef}
                >
                    <div style={{display: 'flex', margin: '0 -8px'}}>
                        {offers?.map((item, index) => (
                            <div key={index} style={{flex: '0 0 63%', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 4px'}}>
                                <img src={item.imagePath} style={{height: 'auto', aspectRatio: 'auto'}}/>
                                <div className="uk-card-body">
                                    <p className="title"><T>{item.title}</T></p>
                                    <p className="description"><T>{item.description}</T></p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                    <img src={offers[0].reward_image_url} style={{height: 'auto', width: '100%', aspectRatio: 'auto'}}/>
                    <div className="uk-card-body">
                        <p className="title">{offers[0].reward_title}</p>
                        <p className="description">{offers[0].reward_message}</p>
                    </div>
                </div>
            )}

            {!!showReward &&
                <ClaimRewardBtn text={'Product Passport'} to={'/nbc'} />
            }
        </div>
    )
}
